// @ts-nocheck
import { MODULE_ACL, PLAN_TYPE } from "./constant";

export const VOICE_PLAN_ACL_MODULE = MODULE_ACL.VOICE_PLANS;

export const VOICE_PLAN_DIRECTION_OPTIONS = PLAN_TYPE.map((p) => ({
  label: p.label,
  value: p.value,
}));

const ACL_BOOLEAN_OPS = ["read", "add", "edit", "delete", "view_permission"];

export function parseModuleOperations(moduleOperations) {
  if (!moduleOperations) return {};
  if (typeof moduleOperations === "object") return moduleOperations;
  try {
    return JSON.parse(moduleOperations);
  } catch {
    return {};
  }
}

export function getAllowedVoicePlanDirections(moduleOperations, userRole, isSuperAdmin) {
  if (isSuperAdmin) {
    return VOICE_PLAN_DIRECTION_OPTIONS.map((o) => o.value);
  }

  const ops = parseModuleOperations(moduleOperations);
  const dirs = ops[VOICE_PLAN_ACL_MODULE]?.plan_directions;
  if (!Array.isArray(dirs) || dirs.length === 0) {
    return null;
  }

  const valid = VOICE_PLAN_DIRECTION_OPTIONS.map((o) => o.value);
  return dirs
    .map((d) => String(d).trim().toUpperCase())
    .filter((d) => valid.includes(d));
}

export function canUseVoicePlanType(moduleOperations, planType, { isSuperAdmin } = {}) {
  if (isSuperAdmin) return true;
  const allowed = getAllowedVoicePlanDirections(moduleOperations, null, false);
  if (allowed === null) return true;
  if (allowed.length === 0) return false;
  return allowed.includes(String(planType || "").trim().toUpperCase());
}

export function isVoicePlanAclActive(moduleEntry) {
  if (!moduleEntry) return false;
  return ACL_BOOLEAN_OPS.some((op) => moduleEntry[op] === true);
}

export function formatPlanDirectionsLabel(directions) {
  if (!Array.isArray(directions) || directions.length === 0) return "—";
  return directions.join(", ");
}

/**
 * Options the current user may assign when building an ACL for sub-users.
 * Super admin: all types. Others: only types in their own ACL plan_directions.
 */
export function getVoicePlanDirectionOptionsForEditor(moduleOperations, isSuperAdmin) {
  const allowed = getAllowedVoicePlanDirections(moduleOperations, null, isSuperAdmin);
  if (isSuperAdmin || allowed === null) {
    return VOICE_PLAN_DIRECTION_OPTIONS;
  }
  return VOICE_PLAN_DIRECTION_OPTIONS.filter((o) => allowed.includes(o.value));
}

export function getParentGrantablePlanDirections(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) {
    return VOICE_PLAN_DIRECTION_OPTIONS.map((o) => o.value);
  }
  const allowed = getAllowedVoicePlanDirections(moduleOperations, null, false);
  if (allowed === null) {
    return VOICE_PLAN_DIRECTION_OPTIONS.map((o) => o.value);
  }
  return allowed;
}

export function normalizeVoicePlanDirectionsForSave(directions, parentGrantable = null) {
  const validPool =
    Array.isArray(parentGrantable) && parentGrantable.length > 0
      ? parentGrantable
      : VOICE_PLAN_DIRECTION_OPTIONS.map((o) => o.value);

  if (!Array.isArray(directions)) return [];
  return [
    ...new Set(
      directions
        .map((d) => String(d).trim().toUpperCase())
        .filter((d) => validPool.includes(d))
    ),
  ];
}
